import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { SECRET_STORAGE_KEY } from './adminApi';
import './AdminLayout.css';

const NAV_ITEMS = [
  { to: '/admin', label: 'Overview', icon: '◆', end: true },
  { to: '/admin/driver-applications', label: 'Driver Applications', icon: '🚗' },
  { to: '/admin/restaurant-applications', label: 'Restaurant Applications', icon: '🍽️' },
  { to: '/admin/reward-fulfillment', label: 'Reward Fulfillment', icon: '🎁' },
  { to: '/admin/screening-room', label: 'Screening Room', icon: '🎞️' },
  { to: '/admin/movie-crawler', label: 'Movie Crawler', icon: '🎬', external: true },
];

export default function AdminLayout({ children }) {
  const [secret, setSecret] = useState(() => sessionStorage.getItem(SECRET_STORAGE_KEY) || '');
  const [secretInput, setSecretInput] = useState('');
  const [gateError, setGateError] = useState(null);

  const handleUnlock = () => {
    if (!secretInput.trim()) { setGateError('Enter the admin secret.'); return; }
    sessionStorage.setItem(SECRET_STORAGE_KEY, secretInput.trim());
    setSecret(secretInput.trim());
    setGateError(null);
  };

  const handleLock = () => {
    sessionStorage.removeItem(SECRET_STORAGE_KEY);
    setSecret('');
    setSecretInput('');
  };

  if (!secret) {
    return (
      <div className="adm-gate-root">
        <div className="adm-gate-card">
          <div className="adm-gate-badge">★</div>
          <h1 className="adm-gate-title">StarView Admin</h1>
          <p className="adm-gate-subtitle">Enter the admin secret to access the review console.</p>
          <input
            type="password"
            className="adm-gate-input"
            value={secretInput}
            onChange={(e) => setSecretInput(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleUnlock()}
            placeholder="Admin secret"
            autoFocus
          />
          {gateError && <div className="adm-gate-error">{gateError}</div>}
          <button className="adm-gate-button" onClick={handleUnlock}>Unlock Console</button>
        </div>
      </div>
    );
  }

  return (
    <div className="adm-root">
      <aside className="adm-sidebar">
        <div className="adm-sidebar-brand">
          <span className="adm-sidebar-star">★</span>
          <span>StarView Admin</span>
        </div>
        <nav className="adm-nav">
          {NAV_ITEMS.map((item) =>
            item.external ? (
              <a key={item.to} href={item.to} className="adm-nav-item">
                <span className="adm-nav-icon">{item.icon}</span>{item.label}
              </a>
            ) : (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) => `adm-nav-item${isActive ? ' adm-nav-item-active' : ''}`}
              >
                <span className="adm-nav-icon">{item.icon}</span>{item.label}
              </NavLink>
            )
          )}
        </nav>
        <button className="adm-lock-button" onClick={handleLock}>Lock Console</button>
      </aside>
      <main className="adm-main">{children(secret)}</main>
    </div>
  );
}
